import { ArrowDown } from 'lucide-react';
import type { Plan } from '../../../data/portfolio-examples';

/**
 * Resumo de orientação no topo. Repete os três preços na mesma ordem das seções
 * e leva direto ao exemplo de cada um, para o visitante saber quantas opções
 * existem antes de começar a rolar.
 */
export default function PlanSummary({ plans }: { plans: Plan[] }) {
  return (
    <ul className="ex-summary">
      {plans.map((plan) => (
        <li key={plan.id}>
          <a className="ex-summary__row" href={`#${plan.anchor}`}>
            <span className="ex-summary__price">{plan.price}</span>
            <span className="ex-summary__name">{plan.name}</span>
            <span className="ex-summary__go">
              Ver e ouvir
              <ArrowDown size={20} strokeWidth={2.5} aria-hidden="true" />
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}
